import React, { useState } from 'react';

// material-ui
import LinearProgress from '@mui/material/LinearProgress';
import Lottie from 'lottie-react';

import styled from 'styled-components';

//constants
import ANIMATION from '../../../../../constants/animation';

import { VariantWithLabel } from 'models/variant.model';

// components
import AlternateListItem from './AlternateListItem';

interface AlternatesListProps {
    alternates: VariantWithLabel[];
    isLoading: boolean;
    isEditable: boolean;
    listView?: boolean;
    isPasteButtonShow?: boolean;
    showPasteAnimation?: boolean;
    customListStyle?: React.CSSProperties;
    wrapText?: boolean;
}

const AlternatesListWrapper: React.FC<
    React.PropsWithChildren<AlternatesListProps>
> = ({
    alternates,
    isLoading,
    isEditable,
    listView,
    isPasteButtonShow,
    showPasteAnimation,
    customListStyle,
    wrapText,
}) => {
    const [selectedAlternate, setSelectedAlternate] = useState<string | null>(
        null,
    );

    if (isLoading) {
        return <LinearProgress color="secondary" />;
    }

    alternates.sort((a, b) => {
        const isMasterVariantA = a.id === a.component_id;
        const isMasterVariantB = b.id === b.component_id;

        if (isMasterVariantA) return -1;
        if (isMasterVariantB) return 1;

        const labelsA = a?.label;
        const labelsB = b?.label;
        const lengthA = labelsA ? 1 : 0;
        const lengthB = labelsB ? 1 : 0;
        return lengthA - lengthB;
    });
    return (
        <List style={customListStyle}>
            {alternates?.map((alternate: VariantWithLabel, index) => {
                return (
                    <AlternateListItem
                        alternateData={alternate}
                        index={index}
                        selectedAlternate={selectedAlternate}
                        setSelectedAlternate={setSelectedAlternate}
                        key={`${alternate.id}-${index}`} //this enhanced key prevents ghost duplicates from rendering
                        isEditable={isEditable}
                        listView={listView}
                        isPasteButtonShow={isPasteButtonShow}
                        wrapText={wrapText}
                    />
                );
            })}
            {showPasteAnimation && (
                <AnimationContainer>
                    <Lottie
                        animationData={ANIMATION.task}
                        loop={true}
                        style={{
                            height: '160px',
                            width: '160px',
                        }}
                    />
                </AnimationContainer>
            )}
        </List>
    );
};

const List = styled.div({
    height: '460px',
    overflow: 'auto',
    position: 'relative',
});

const AnimationContainer = styled.div({
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
});

export default AlternatesListWrapper;
